import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import CardActions from "@mui/material/CardActions";
import { useTranslation } from "next-i18next";

import Link from "../../Common/Link";

const PricingCards = () => {
  const { t } = useTranslation("pricing");
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <>
      <Box marginTop={3} marginBottom={12}>
        <Typography
          component={"h1"}
          fontWeight={700}
          variant={"h3"}
          align={"center"}
        >
          {t("pricing_cards.title")}
        </Typography>
      </Box>
      <Box>
        <Box display={"flex"} justifyContent={"center"} marginBottom={3}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  color="secondary"
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label={t("pricing_cards.small_town_option")}
            />
          </FormGroup>
        </Box>
        <Grid container spacing={4}>
          {t("pricings", { returnObjects: true }).map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box
                component={Card}
                height={"100%"}
                display={"flex"}
                flexDirection={"column"}
                boxShadow={i == 1 ? 4 : 0}
                borderRadius={4}
              >
                <Box component={CardContent} padding={4}>
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                  >
                    <Typography
                      variant={"h6"}
                      component="p"
                      fontWeight={600}
                      gutterBottom
                    >
                      {item.title}
                    </Typography>
                    {checked && (
                      <Typography
                        variant={"h4"}
                        component="span"
                        color={"primary"}
                        fontWeight={600}
                        gutterBottom
                      >
                        {item.price}
                      </Typography>
                    )}
                  </Box>
                  <Box>{item.description}</Box>
                </Box>
                <Box flexGrow={1} />
                <Box
                  component={CardActions}
                  justifyContent={"center"}
                  paddingX={4}
                  paddingBottom={4}
                >
                  <Button
                    size={"large"}
                    variant={item.isHighlighted ? "contained" : "outlined"}
                    component={Link}
                    href="/demo"
                  >
                    {checked ? t("contact_us") : t("request_quote")}
                  </Button>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default PricingCards;
